import React from "react";
import ComponentContact from "../Components/Footer/ComponentContact/ComponentContact";
import Footer from "../Components/Footer/Footer";
import NavBar from "../Components/NavBar/NavBar";
function Contact() {
  return (
    <div>
      <NavBar />
      <ComponentContact />
      <Footer />
    </div>
  );
}

export default Contact;
